const night = {
  113: require("../asset/night/113.svg").default,
  116: require("../asset/night/116.svg").default,
  119: require("../asset/night/119.svg").default,
  122: require("../asset/night/122.svg").default,
  143: require("../asset/night/143.svg").default,
  176: require("../asset/night/176.svg").default,
  179: require("../asset/night/179.svg").default,
  182: require("../asset/night/182.svg").default,
  185: require("../asset/night/185.svg").default,
  200: require("../asset/night/200.svg").default,
  227: require("../asset/night/227.svg").default,
  230: require("../asset/night/230.svg").default,
  248: require("../asset/night/248.svg").default,
  260: require("../asset/night/260.svg").default,
  263: require("../asset/night/263.svg").default,
  266: require("../asset/night/266.svg").default,
  281: require("../asset/night/281.svg").default,
  284: require("../asset/night/284.svg").default,
  293: require("../asset/night/293.svg").default,
  296: require("../asset/night/296.svg").default,
  299: require("../asset/night/299.svg").default,
  302: require("../asset/night/302.svg").default,
  305: require("../asset/night/305.svg").default,
  308: require("../asset/night/308.svg").default,
  311: require("../asset/night/311.svg").default,
  314: require("../asset/night/314.svg").default,
  317: require("../asset/night/317.svg").default,
  320: require("../asset/night/320.svg").default,
  323: require("../asset/night/323.svg").default,
  326: require("../asset/night/326.svg").default,
  329: require("../asset/night/329.svg").default,
  332: require("../asset/night/332.svg").default,
  335: require("../asset/night/335.svg").default,
  338: require("../asset/night/338.svg").default,
  350: require("../asset/night/350.svg").default,
  353: require("../asset/night/353.svg").default,
  356: require("../asset/night/356.svg").default,
  359: require("../asset/night/359.svg").default,
  362: require("../asset/night/362.svg").default,
  365: require("../asset/night/365.svg").default,
  368: require("../asset/night/368.svg").default,
  371: require("../asset/night/371.svg").default,
  374: require("../asset/night/374.svg").default,
  377: require("../asset/night/377.svg").default,
  386: require("../asset/night/386.svg").default,
  389: require("../asset/night/389.svg").default,
  392: require("../asset/night/392.svg").default,
  395: require("../asset/night/395.svg").default,
};

export default night;
